import React, { useEffect } from 'react'
import { setPageName } from '../../store/redux/reducers/pageNameSlice'
import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../store/redux/hooks'
import { useNavigate } from 'react-router-dom'
import { KeyboardReturn } from '@mui/icons-material'

const UnauthorizedView = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(setPageName(t('page.name.unauthorized')))
  }, [dispatch, t])

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography variant="h3">{t('page.unauthorized.accessDenied')}</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        {t('page.unauthorized.noPermission')}
      </Typography>
      <Button
        variant="contained"
        startIcon={<KeyboardReturn />}
        sx={{ mt: 6 }}
        onClick={() => navigate('/home', { replace: true })}
      >
        {t('page.unauthorized.return')}
      </Button>
    </Box>
  )
}

export default UnauthorizedView
